/** ASP.NET may return a bare array or legacy `{ $values: [...] }`. */
export function unwrapList(data) {
  if (!data) return [];
  if (Array.isArray(data)) return data;
  if (Array.isArray(data.$values)) return data.$values;
  if (Array.isArray(data.data)) return data.data;
  return [];
}

export function normalizeClient(row) {
  if (!row) return null;
  return {
    id: row.id ?? row.Id,
    agencyName: row.agencyName ?? row.AgencyName ?? "",
    email: row.email ?? row.Email ?? "",
    phoneNumber: row.phoneNumber ?? row.PhoneNumber ?? "",
    streetAddress: row.streetAddress ?? row.StreetAddress ?? "",
    city: row.city ?? row.City ?? "",
    state: row.state ?? row.State ?? "",
    country: row.country ?? row.Country ?? "",
    postalCode: row.postalCode ?? row.PostalCode ?? "",
    gstNumber: row.gstNumber ?? row.GstNumber ?? "",
    license: row.license ?? row.License ?? "",
    registrationNumber: row.registrationNumber ?? row.RegistrationNumber ?? "",
    isActive: row.isActive ?? row.IsActive ?? true,
  };
}

export function normalizeClients(data) {
  return unwrapList(data).map(normalizeClient).filter(Boolean);
}
